import { atomWithStorage } from 'jotai/utils';
import { useAtom } from 'jotai';
import { useQueryClient } from 'react-query';
import { API_ENDPOINTS } from '@/data/client/endpoints';

export interface NSFWSettings {
  mature: boolean;
  explicit: boolean;
  blur: boolean;
  confirmed18: boolean;
}

const DEFAULT_SETTINGS: NSFWSettings = {
  mature: false,
  explicit: false,
  blur: true,
  confirmed18: false,
};

export const nsfwSettingsAtom = atomWithStorage<NSFWSettings>(
  'nsfw-settings',
  DEFAULT_SETTINGS
);

export function useNSFWSettings() {
  const [settings, setSettings] = useAtom(nsfwSettingsAtom);
  const queryClient = useQueryClient();

  const updateSettings = (newSettings: Partial<NSFWSettings>) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      ...newSettings,
    }));

    // Invalidate relevant queries to refresh data with new NSFW settings
    queryClient.invalidateQueries(API_ENDPOINTS.PRODUCTS);
    queryClient.invalidateQueries(API_ENDPOINTS.PRODUCTS_POPULAR);
    // Add any other relevant query keys that should be refreshed
  };

  return {
    settings,
    updateSettings,
  };
}
